module.exports = __webpack_public_path__ + "app-static/img/ok-rulers.309890cb.png";